import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index"
import AUTH_LEVEL from "../configs/authLevel"
import Maintenance from '@/views/Maintenance.vue'

import b64 from "../tools/b64"

/* Login */
import Login from '@/views/Login.vue'

/* Home */
import Home from '@/views/Home.vue'
import Tyc from '@/views/Tyc.vue'
import Products from '@/views/Products.vue'
import Product from '@/views/Product.vue'
import ProductByCategory from '@/views/ProductByCategory.vue'
import Services from '@/views/Services.vue'
import Service from '@/views/Service.vue'
import ServiceByCategory from '@/views/ServiceByCategory.vue'
import Search from '@/views/Search.vue'

/* Account */
import MyProfile from '@/views/account/MyProfile.vue'
import MyPurchases from "@/views/account/MyPurchases.vue"
import MyPurchase from "@/views/account/MyPurchase.vue"
import MySales from "@/views/account/MySales.vue"
import MySale from "@/views/account/MySale.vue"
import MyNotifications from "@/views/account/MyNotifications.vue"
import MyBalance from "@/views/account/MyBalance.vue"

/* Seller */
import Sell from '@/views/seller/Sell.vue'
import SellProduct from '@/views/seller/SellProduct.vue'
import SellService from '@/views/seller/SellService.vue'
import Publications from '@/views/seller/Publications.vue'
import Publication from '@/views/seller/Publication.vue'
import PublicationService from '@/views/seller/PublicationService.vue'

/* Admin */
import Dashboard from '@/views/admin/Dashboard.vue'
import Categories from '@/views/admin/Categories.vue'
import Category from '@/views/admin/Category.vue'
import Specs from '@/views/admin/Specs.vue'
import Spec from '@/views/admin/Spec.vue'
import AdminProducts from '../views/admin/Products.vue'
import AdminProduct from '../views/admin/Product.vue'
import AdminCancelProduct from '../views/admin/AdminCancelProduct.vue'
import AdminServices from '../views/admin/Services.vue'
import AdminService from '../views/admin/Service.vue'
import AdminCancelService from '../views/admin/AdminCancelService.vue'
import AdminBackUp from "../views/admin/AdminBackUp.vue"
import AdminPurchases from "../views/admin/Purchases.vue"
import AdminPurchase from "../views/admin/Purchase.vue"
import AdminTransactions from "../views/admin/Transactions.vue"
import PurchasesNotification from "../views/admin/PurchasesNotification.vue";
import EditTyc from "../views/admin/EditTyc.vue"

import Cart from '../views/Cart'
import Buy from '../views/Buy'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/login/:path',
    name: 'LoginPath',
    component: Login
  },
  {
    path: `/tyc`,
    name: 'Tyc',
    component: Tyc
  },
  {
    path: `/productos`,
    name: 'Products',
    component: Products
  },
  {
    path: `/servicios`,
    name: 'Services',
    component: Services
  },
  {
    path: `/producto/:id/:title`,
    name: 'product',
    component: Product
  },

  {
    path: `/servicio/:id/:title`,
    name: 'service',
    component: Service
  },
  {
    path: '/vender',
    name: 'Sell',
    component: Sell,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  },
  {
    path: '/vender/producto',
    name: 'SellerProduct',
    component: SellProduct,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  },
  {
    path: '/vender/servicio',
    name: 'SellService',
    component: SellService,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  },
  {
    path: '/admin',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/categories',
    name: 'Categories',
    component: Categories,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/products',
    name: 'AdminProducts',
    component: AdminProducts,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/product/:id/:title',
    name: 'AdminProduct',
    component: AdminProduct,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/cancel-product/:id/:title',
    name: 'AdminCancelProduct',
    component: AdminCancelProduct,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/services',
    name: 'AdminServices',
    component: AdminServices,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/service/:id/:title',
    name: 'AdminService',
    component: AdminService,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/cancel-service/:id/:title',
    name: 'AdminCancelService',
    component: AdminCancelService,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/back-up',
    name: 'AdminBackUp',
    component: AdminBackUp,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/tyc',
    name: 'EditTyc',
    component: EditTyc,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/category/:id/:title',
    name: 'Category',
    component: Category,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/specs',
    name: 'Specs',
    component: Specs,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/admin/spec/:id/:title',
    name: 'Spec',
    component: Spec,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  }, {
    path: '/admin/ventas',
    name: 'AdminPurchases',
    component: AdminPurchases,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  }, {
    path: '/admin/venta/:id',
    name: 'AdminPurchase',
    component: AdminPurchase,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  }, {
    path: '/admin/transacciones',
    name: 'AdminTransactions',
    component: AdminTransactions,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.ADMINISTRATOR
    }
  },
  {
    path: '/mis-publicaciones',
    name: 'Publications',
    component: Publications,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  },
  {
    path: '/mis-publicaciones/producto/:id/:title',
    name: 'Publication',
    component: Publication,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  },
  {
    path: '/mis-publicaciones/servicio/:id/:title',
    name: 'PublicationService',
    component: PublicationService,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  },
  {
    path: `/productos/:category/:filters/:order`,
    name: 'FindProduct',
    component: Products
  },
  {
    path: `/productos/:category`,
    name: 'ProductsByCategory',
    component: ProductByCategory
  },
  {
    path: `/servicios/:category`,
    name: 'ServicesByCategory',
    component: ServiceByCategory
  }, {
    path: '/mi-balance',
    name: 'MyBalance',
    component: MyBalance,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  },
  {
    path: '/mis-datos',
    name: 'MyProfile',
    component: MyProfile,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  }, {
    path: '/mis-compras',
    name: 'MyPurchases',
    component: MyPurchases,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  }, {
    path: '/mi-compra/:id',
    name: 'MyPurchase',
    component: MyPurchase,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  }, {
    path: '/mis-ventas',
    name: 'MySales',
    component: MySales,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  }, {
    path: '/mis-notificaciones',
    name: 'MyNotifications',
    component: MyNotifications,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  }, {
    path: '/mi-venta/:id',
    name: 'MySale',
    component: MySale,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  }, {
    path: '/search/:title',
    name: 'Search',
    component: Search
  }, {
    path: '/carrito',
    name: 'Cart',
    component: Cart
  }, {
    path: '/comprar',
    name: 'Buy',
    component: Buy,
    meta: {
      requiresAuth: true,
      role: AUTH_LEVEL.USER_LOGGED_IN
    }
  }, {
    path: '/admin/ventas/notificar-vendedor',
    name: 'PurchasesNotification',
    component: PurchasesNotification
  }, {
    path: '/en-mantenimiento',
    name: 'Maintenance',
    component: Maintenance
  }, {
    path: '*',
    name: 'HomeDefault',
    component: Home
  }, {
    path: '/sistemaapple',
    beforeEnter() { location.href = 'https://www.sistemaapple.com.mx/registro' }
  }


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  from;
  if (!to.meta.requiresAuth)
    return next();

  if (!store.state.auth.username)
    return next({ name: 'LoginPath', params: { path: b64.encode(to.path) } });

  if (!AUTH_LEVEL.getNeedToBe(to.meta.role).includes(store.state.auth.userType)) {
    return next({ name: 'Home' });
  }

  next()
})

export default router
